import React from "react";
import { Box, Flex, IconOnePassMembershipCard, Text } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CurrentBenefit = function CurrentBenefit() {
  return ___EmotionJSX(Flex, {
    alignItems: "center"
  }, ___EmotionJSX(Box, {
    flex: "1 1 auto",
    mr: 5
  }, ___EmotionJSX(IconOnePassMembershipCard, {
    color: "onePass.primaryDarker",
    width: "42px",
    height: "auto"
  })), ___EmotionJSX(Box, {
    flex: "1 1 auto",
    width: "100%"
  }, ___EmotionJSX(Text, {
    fontSize: "base",
    color: "onePass.textPrimary",
    m: 0,
    fontWeight: "normal"
  }, "All current Catch and OnePass benefits, for the same price.")));
};